
<!--Dropdown for life events-->
<mat-form-field appearance="outline" class="event" [style.width]="fieldWidth" >
  <mat-label>{{componentDisplayAttributes.formControlAttributes.label || 'Qualifying Life Event'}}</mat-label>
  <mat-select aria-label="Qualifying Life Event" [formControlName]="componentDisplayAttributes.formControlAttributes.formControlName" [compareWith]="compareWithFn" (selectionChange)="eventChanged('change',$event); onLifeEventSelected($event.value?.lifeEventId)">
    @if (!loadingOptions) {
      @for (lifeEvent of qualifyingLifeEvents; track lifeEvent) {
        <mat-option [value]="lifeEvent">
          {{lifeEvent.lifeEventDescription}}
        </mat-option>
      }
    } @else {
      <mat-option>
            <div class="loading-option">
              <span>Loading Options</span>
              <mat-spinner [diameter]="24"></mat-spinner>
            </div>
          </mat-option>
        }
  </mat-select>
  @if (eventFormControls[componentDisplayAttributes.formControlAttributes.formControlName].errors?.required) {
    <mat-error>{{componentDisplayAttributes?.custom?.lifeEventRequiredMessage || 'Required'}}</mat-error>
  }
</mat-form-field>